
const Tool = {
    storage:{
        ls:window.localStorage,
        ss:window.sessionStorage,
        /*设置cookie*/
        setCookie (name, value, day) {
            var setting = arguments[0];
            if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object'){
                for (var i in setting) {
                    var oDate = new Date();
                    oDate.setDate(oDate.getDate() + day);
                    document.cookie = i + '=' + setting[i] + ';expires=' + oDate;
                }
            }else{
                var oDate = new Date();
                oDate.setDate(oDate.getDate() + day);
                document.cookie = name + '=' + value + ';expires=' + oDate;
            }
        },
        /*获取cookie*/
        getCookie (name) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == name) {
                    return arr2[1];
                }
            }
            return '';
        },
        /*删除cookie*/
        removeCookie (name) {
            this.setCookie(name, 1, -1);
        },
        /*设置localStorage*/
        setLocal(key, val) {
            var setting = arguments[0];
            if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object'){
                for(var i in setting){
                    this.ls.setItem(i, JSON.stringify(setting[i]))
                }
            }else{
                this.ls.setItem(key, JSON.stringify(val))
            }
        },
        getLocal(key) {
            if (key) return JSON.parse(this.ls.getItem(key))
            return null;
        },
        removeLocal(key) {
            this.ls.removeItem(key)
        },
        /*移除所有localStorage*/
        clearLocal() {
            this.ls.clear()
        },

        /*设置sessionStorage*/
        setSession(key, val) {
            var setting = arguments[0];
            if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object'){
                for(var i in setting){
                    this.ss.setItem(i, JSON.stringify(setting[i]))
                }
            }else{
                this.ss.setItem(key, JSON.stringify(val))
            }
        },
        /*获取sessionStorage*/
        getSession(key) {
            return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) :''
        },
        /*移除sessionStorage*/
        removeSession(key) {
            this.ss.removeItem(key)
        },
        /*移除所有sessionStorage*/
        clearSession() {
            this.ss.clear()
        }
    },
    type:{
        isString (o) { //是否字符串
            return Object.prototype.toString.call(o).slice(8, -1) === 'String'
        },

        isNumber (o) { //是否数字
            return Object.prototype.toString.call(o).slice(8, -1) === 'Number'
        },

        isBoolean (o) { //是否boolean
            return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean'
        },

        isFunction (o) { //是否函数
            return Object.prototype.toString.call(o).slice(8, -1) === 'Function'
        },

        isNull (o) { //是否为null
            return Object.prototype.toString.call(o).slice(8, -1) === 'Null'
        },

        isUndefined (o) { //是否undefined
            return Object.prototype.toString.call(o).slice(8, -1) === 'Undefined'
        },

        isObj (o) { //是否对象
            return Object.prototype.toString.call(o).slice(8, -1) === 'Object'
        },

        isArray (o) { //是否数组
            return Object.prototype.toString.call(o).slice(8, -1) === 'Array'
        },

        isDate (o) { //是否时间
            return Object.prototype.toString.call(o).slice(8, -1) === 'Date'
        },

        isRegExp (o) { //是否正则
            return Object.prototype.toString.call(o).slice(8, -1) === 'RegExp'
        },

        isError (o) { //是否错误对象
            return Object.prototype.toString.call(o).slice(8, -1) === 'Error'
        },

        isSymbol (o) { //是否Symbol函数
            return Object.prototype.toString.call(o).slice(8, -1) === 'Symbol'
        },

        isPromise (o) { //是否Promise对象
            return Object.prototype.toString.call(o).slice(8, -1) === 'Promise'
        },

        isSet (o) { //是否Set对象
            return Object.prototype.toString.call(o).slice(8, -1) === 'Set'
        },

        isFalse (o) {
            if (o == '' || o == undefined || o == null || o == 'null' || o == 'undefined' || o == 0 || o == false || o == NaN) return true
            return false
        },

        isTrue (o) {
            return !this.isFalse(o)
        },

        isIos () {
            var u = navigator.userAgent;
            if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {//安卓手机
                // return "Android";
                return false
            } else if (u.indexOf('iPhone') > -1) {//苹果手机
                // return "iPhone";
                return true
            } else if (u.indexOf('iPad') > -1) {//iPad
                // return "iPad";
                return false
            } else if (u.indexOf('Windows Phone') > -1) {//winphone手机
                // return "Windows Phone";
                return false
            }else{
                return false
            }
        },

        isPC () { //是否为PC端
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        os(){
            var sUserAgent = navigator.userAgent;
            var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
            var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
            if (isMac) return "Mac";
            var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
            if (isUnix) return "Unix";
            var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
            if (isLinux) return "Linux";
            if (isWin) {
                var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
                if (isWin2K) return "Win2000";
                var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
                if (isWinXP) return "WinXP";
                var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
                if (isWin2003) return "Win2003";
                var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
                if (isWinVista) return "WinVista";
                var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
                if (isWin7) return "Win7";
            }
            return "other";
        },
        browserVersion:function(){
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
            var isIE = userAgent.indexOf("compatible") > -1
                && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
            var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
            var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
            var isSafari = userAgent.indexOf("Safari") > -1
                && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
            var isChrome = userAgent.indexOf("Chrome") > -1
                && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return "IE7";
                } else if (fIEVersion == 8) {
                    return "IE8";
                } else if (fIEVersion == 9) {
                    return "IE9";
                } else if (fIEVersion == 10) {
                    return "IE10";
                } else if (fIEVersion == 11) {
                    return "IE11";
                } else {
                    return "0";
                }//IE版本过低
                return "IE";
            }
            if (isOpera) {
                return "Opera";
            }
            if (isEdge) {
                return "Edge";
            }
            if (isFF) {
                return "FF";
            }
            if (isSafari) {
                return "Safari";
            }
            if (isChrome) {
                return "Chrome";
            }
            return 'other';
        },
        browserType(){
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
            var isIE = userAgent.indexOf("compatible") > -1
                && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
            var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
            var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
            var isSafari = userAgent.indexOf("Safari") > -1
                && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
            var isChrome = userAgent.indexOf("Chrome") > -1
                && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return "IE7";
                } else if (fIEVersion == 8) {
                    return "IE8";
                } else if (fIEVersion == 9) {
                    return "IE9";
                } else if (fIEVersion == 10) {
                    return "IE10";
                } else if (fIEVersion == 11) {
                    return "IE11";
                } else {
                    return "0";
                }//IE版本过低
                return "IE";
            }
            if (isOpera) {
                return "Opera";
            }
            if (isEdge) {
                return "Edge";
            }
            if (isFF) {
                return "FF";
            }
            if (isSafari) {
                return "Safari";
            }
            if (isChrome) {
                return "Chrome";
            }
            return 'other';
        },

        checkStr (str, type) {
            switch (type) {
                case 'phone':   //手机号码
                    return /^1[1|2|3|4|5|6|7|8|9][0-9]{9}$/.test(str);
                case 'tel':     //座机
                    return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
                case 'card':    //身份证
                    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str);
                case 'pwd':     //密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
                    return /^[a-zA-Z]\w{5,17}$/.test(str)
                case 'postal':  //邮政编码
                    return /[1-9]\d{5}(?!\d)/.test(str);
                case 'QQ':      //QQ号
                    return /^[1-9][0-9]{4,9}$/.test(str);
                case 'email':   //邮箱
                    return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
                case 'money':   //金额(小数点2位)
                    return /^\d*(?:\.\d{0,2})?$/.test(str);
                case 'URL':     //网址
                    return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str)
                case 'IP':      //IP
                    return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str);
                case 'date':    //日期时间
                    return /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) || /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
                case 'number':  //数字
                    return /^[0-9]$/.test(str);
                case 'english': //英文
                    return /^[a-zA-Z]+$/.test(str);
                case 'chinese': //中文
                    return /^[\u4E00-\u9FA5]+$/.test(str);
                case 'lower':   //小写
                    return /^[a-z]+$/.test(str);
                case 'upper':   //大写
                    return /^[A-Z]+$/.test(str);
                case 'HTML':    //HTML标记
                    return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
                default:
                    return true;
            }
        },
        // 严格的身份证校验
        isCardID(sId) {
            if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(sId)) {
                //alert('你输入的身份证长度或格式错误')
                return false
            }
            //身份证城市
            var aCity={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"};
            if(!aCity[parseInt(sId.substr(0,2))]) {
                // alert('你的身份证地区非法')
                return false
            }

            // 出生日期验证
            var sBirthday=(sId.substr(6,4)+"-"+Number(sId.substr(10,2))+"-"+Number(sId.substr(12,2))).replace(/-/g,"/"),
                d = new Date(sBirthday)
            if(sBirthday != (d.getFullYear()+"/"+ (d.getMonth()+1) + "/" + d.getDate())) {
                //alert('身份证上的出生日期非法')
                return false
            }

            // 身份证号码校验
            var sum = 0,
                weights =  [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                codes = "10X98765432"
            for (var i = 0; i < sId.length - 1; i++) {
                sum += sId[i] * weights[i];
            }
            var last = codes[sum % 11]; //计算出来的最后一位身份证号码
            if (sId[sId.length-1] != last) {
                //alert('你输入的身份证号非法')
                return false
            }
            return true
        }
    },
    date:{
        /**
         * 和PHP一样的时间戳格式化函数
         * @param  {string} format    格式
         * @param  {int}    timestamp 要格式化的时间 默认为当前时间
         * @return {string}           格式化的时间字符串
         */
        formatDate: function formatDate(format, timestamp) {
            var a,
                jsdate = timestamp ? new Date(timestamp * 1000) : new Date();
            var pad = function pad(n, c) {
                if ((n = n + "").length < c) {
                    return new Array(++c - n.length).join("0") + n;
                } else {
                    return n;
                }
            };
            var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var txt_ordin = {
                1: "st",
                2: "nd",
                3: "rd",
                21: "st",
                22: "nd",
                23: "rd",
                31: "st"
            };
            var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var f = {
                // Day
                d: function d() {
                    return pad(f.j(), 2);
                },
                D: function D() {
                    return f.l().substr(0, 3);
                },
                j: function j() {
                    return jsdate.getDate();
                },
                l: function l() {
                    return txt_weekdays[f.w()];
                },
                N: function N() {
                    return f.w() + 1;
                },
                S: function S() {
                    return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th';
                },
                w: function w() {
                    return jsdate.getDay();
                },
                z: function z() {
                    var thumb = new Date(jsdate.getFullYear() + "/1/1");
                    return (jsdate - thumb) / 864e5 >> 0;
                },
                // Week
                W: function W() {
                    var a = f.z(),
                        b = 364 + f.L() - a;
                    var nd2,
                        nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
                    if (b <= 2 && (jsdate.getDay() || 7) - 1 <= 2 - b) {
                        return 1;
                    } else {
                        if (a <= 2 && nd >= 4 && a >= 6 - nd) {
                            nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
                            var thumb = Math.round(nd2.getTime() / 1000);
                            // @ts-ignore
                            thumb = date("W", thumb);
                            return thumb;
                        } else {
                            return 1 + (nd <= 3 ? (a + nd) / 7 : (a - (7 - nd)) / 7) >> 0;
                        }
                    }
                },
                // Month
                F: function F() {
                    return txt_months[f.n()];
                },
                m: function m() {
                    return pad(f.n(), 2);
                },
                M: function M() {
                    return f.F().substr(0, 3);
                },
                n: function n() {
                    return jsdate.getMonth() + 1;
                },
                t: function t() {
                    var n;
                    if ((n = jsdate.getMonth() + 1) == 2) {
                        return 28 + f.L();
                    } else {
                        if (n & 1 && n < 8 || !(n & 1) && n > 7) {
                            return 31;
                        } else {
                            return 30;
                        }
                    }
                },
                // Year
                L: function L() {
                    var y = f.Y();
                    return !(y & 3) && (y % 1e2 || !(y % 4e2)) ? 1 : 0;
                },
                //o not supported yet
                Y: function Y() {
                    return jsdate.getFullYear();
                },
                y: function y() {
                    return (jsdate.getFullYear() + "").slice(2);
                },
                // Time
                a: function a() {
                    return jsdate.getHours() > 11 ? "pm" : "am";
                },
                A: function A() {
                    return f.a().toUpperCase();
                },
                B: function B() {
                    // peter paul koch:
                    var off = (jsdate.getTimezoneOffset() + 60) * 60;
                    var theSeconds = jsdate.getHours() * 3600 + jsdate.getMinutes() * 60 + jsdate.getSeconds() + off;
                    var beat = Math.floor(theSeconds / 86.4);
                    if (beat > 1000) beat -= 1000;
                    if (beat < 0) beat += 1000;
                    if (String(beat).length == 1) beat = "00" + beat;
                    if (String(beat).length == 2) beat = "0" + beat;
                    return beat;
                },
                g: function g() {
                    return jsdate.getHours() % 12 || 12;
                },
                G: function G() {
                    return jsdate.getHours();
                },
                h: function h() {
                    return pad(f.g(), 2);
                },
                H: function H() {
                    return pad(jsdate.getHours(), 2);
                },
                i: function i() {
                    return pad(jsdate.getMinutes(), 2);
                },
                s: function s() {
                    return pad(jsdate.getSeconds(), 2);
                },
                //u not supported yet
                // Timezone
                //e not supported yet
                //I not supported yet
                O: function O() {
                    var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
                    if (jsdate.getTimezoneOffset() > 0) t = "-" + t;else t = "+" + t;
                    return t;
                },
                P: function P() {
                    var O = f.O();
                    return O.substr(0, 3) + ":" + O.substr(3, 2);
                },
                //T not supported yet
                //Z not supported yet
                // Full Date/Time
                c: function c() {
                    return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P();
                },
                //r not supported yet
                U: function U() {
                    return Math.round(jsdate.getTime() / 1000);
                }
            };
            return format.replace(/[\\]?([a-zA-Z])/g, function (t, s) {
                var ret = "";
                if (t != s) {
                    // escaped
                    ret = s;
                } else if (f[s]) {
                    // a date function exists
                    ret = f[s]();
                } else {
                    // nothing special
                    ret = s;
                }
                return ret;
            });
        },
        /**
         * 和PHP一样的时间字符串转时间戳
         * @param str
         * @param now
         * @returns {*}
         */
        strtotime: function strtotime(str, now) {
            var reSpace = '[ \\t]+';
            var reSpaceOpt = '[ \\t]*';
            var reMeridian = '(?:([ap])\\.?m\\.?([\\t ]|$))';
            var reHour24 = '(2[0-4]|[01]?[0-9])';
            var reHour24lz = '([01][0-9]|2[0-4])';
            var reHour12 = '(0?[1-9]|1[0-2])';
            var reMinute = '([0-5]?[0-9])';
            var reMinutelz = '([0-5][0-9])';
            var reSecond = '(60|[0-5]?[0-9])';
            var reSecondlz = '(60|[0-5][0-9])';
            var reFrac = '(?:\\.([0-9]+))';
            var reDayfull = 'sunday|monday|tuesday|wednesday|thursday|friday|saturday';
            var reDayabbr = 'sun|mon|tue|wed|thu|fri|sat';
            var reDaytext = reDayfull + '|' + reDayabbr + '|weekdays?';
            var reReltextnumber = 'first|second|third|fourth|fifth|sixth|seventh|eighth?|ninth|tenth|eleventh|twelfth';
            var reReltexttext = 'next|last|previous|this';
            var reReltextunit = '(?:second|sec|minute|min|hour|day|fortnight|forthnight|month|year)s?|weeks|' + reDaytext;
            var reYear = '([0-9]{1,4})';
            var reYear2 = '([0-9]{2})';
            var reYear4 = '([0-9]{4})';
            var reYear4withSign = '([+-]?[0-9]{4})';
            var reMonth = '(1[0-2]|0?[0-9])';
            var reMonthlz = '(0[0-9]|1[0-2])';
            var reDay = '(?:(3[01]|[0-2]?[0-9])(?:st|nd|rd|th)?)';
            var reDaylz = '(0[0-9]|[1-2][0-9]|3[01])';
            var reMonthFull = 'january|february|march|april|may|june|july|august|september|october|november|december';
            var reMonthAbbr = 'jan|feb|mar|apr|may|jun|jul|aug|sept?|oct|nov|dec';
            var reMonthroman = 'i[vx]|vi{0,3}|xi{0,2}|i{1,3}';
            var reMonthText = '(' + reMonthFull + '|' + reMonthAbbr + '|' + reMonthroman + ')';
            var reTzCorrection = '((?:GMT)?([+-])' + reHour24 + ':?' + reMinute + '?)';
            var reDayOfYear = '(00[1-9]|0[1-9][0-9]|[12][0-9][0-9]|3[0-5][0-9]|36[0-6])';
            var reWeekOfYear = '(0[1-9]|[1-4][0-9]|5[0-3])';
            var processMeridian = function processMeridian(hour, meridian) {
                meridian = meridian && meridian.toLowerCase();
                switch (meridian) {
                    case 'a':
                        hour += hour === 12 ? -12 : 0;
                        break;
                    case 'p':
                        hour += hour !== 12 ? 12 : 0;
                        break;
                }
                return hour;
            };
            var processYear = function processYear(yearStr) {
                var year = +yearStr;
                if (yearStr.length < 4 && year < 100) {
                    year += year < 70 ? 2000 : 1900;
                }
                return year;
            };
            var lookupMonth = function lookupMonth(monthStr) {
                var ob = {
                    jan: 0,
                    january: 0,
                    i: 0,
                    feb: 1,
                    february: 1,
                    ii: 1,
                    mar: 2,
                    march: 2,
                    iii: 2,
                    apr: 3,
                    april: 3,
                    iv: 3,
                    may: 4,
                    v: 4,
                    jun: 5,
                    june: 5,
                    vi: 5,
                    jul: 6,
                    july: 6,
                    vii: 6,
                    aug: 7,
                    august: 7,
                    viii: 7,
                    sep: 8,
                    sept: 8,
                    september: 8,
                    ix: 8,
                    oct: 9,
                    october: 9,
                    x: 9,
                    nov: 10,
                    november: 10,
                    xi: 10,
                    dec: 11,
                    december: 11,
                    xii: 11
                };
                return ob[monthStr.toLowerCase()];
            };
            var lookupWeekday = function lookupWeekday(dayStr, desiredSundayNumber) {
                if (desiredSundayNumber === void 0) {
                    desiredSundayNumber = 0;
                }
                var dayNumbers = {
                    mon: 1,
                    monday: 1,
                    tue: 2,
                    tuesday: 2,
                    wed: 3,
                    wednesday: 3,
                    thu: 4,
                    thursday: 4,
                    fri: 5,
                    friday: 5,
                    sat: 6,
                    saturday: 6,
                    sun: 0,
                    sunday: 0
                };
                return dayNumbers[dayStr.toLowerCase()] || desiredSundayNumber;
            };
            var lookupRelative = function lookupRelative(relText) {
                var relativeNumbers = {
                    last: -1,
                    previous: -1,
                    this: 0,
                    first: 1,
                    next: 1,
                    second: 2,
                    third: 3,
                    fourth: 4,
                    fifth: 5,
                    sixth: 6,
                    seventh: 7,
                    eight: 8,
                    eighth: 8,
                    ninth: 9,
                    tenth: 10,
                    eleventh: 11,
                    twelfth: 12
                };
                var relativeBehavior = {
                    this: 1
                };
                var relTextLower = relText.toLowerCase();
                return {
                    amount: relativeNumbers[relTextLower],
                    behavior: relativeBehavior[relTextLower] || 0
                };
            };
            var processTzCorrection = function processTzCorrection(tzOffset, oldValue) {
                var reTzCorrectionLoose = /(?:GMT)?([+-])(\d+)(:?)(\d{0,2})/i;
                tzOffset = tzOffset && tzOffset.match(reTzCorrectionLoose);
                if (!tzOffset) {
                    return oldValue;
                }
                var sign = tzOffset[1] === '-' ? 1 : -1;
                var hours = +tzOffset[2];
                var minutes = +tzOffset[4];
                if (!tzOffset[4] && !tzOffset[3]) {
                    minutes = Math.floor(hours % 100);
                    hours = Math.floor(hours / 100);
                }
                return sign * (hours * 60 + minutes);
            };
            var formats = {
                yesterday: {
                    regex: /^yesterday/i,
                    name: 'yesterday',
                    callback: function callback() {
                        this.rd -= 1;
                        return this.resetTime();
                    }
                },
                now: {
                    regex: /^now/i,
                    name: 'now'
                    // do nothing
                },
                noon: {
                    regex: /^noon/i,
                    name: 'noon',
                    callback: function callback() {
                        return this.resetTime() && this.time(12, 0, 0, 0);
                    }
                },
                midnightOrToday: {
                    regex: /^(midnight|today)/i,
                    name: 'midnight | today',
                    callback: function callback() {
                        return this.resetTime();
                    }
                },
                tomorrow: {
                    regex: /^tomorrow/i,
                    name: 'tomorrow',
                    callback: function callback() {
                        this.rd += 1;
                        return this.resetTime();
                    }
                },
                timestamp: {
                    regex: /^@(-?\d+)/i,
                    name: 'timestamp',
                    callback: function callback(match, timestamp) {
                        this.rs += +timestamp;
                        this.y = 1970;
                        this.m = 0;
                        this.d = 1;
                        this.dates = 0;
                        return this.resetTime() && this.zone(0);
                    }
                },
                firstOrLastDay: {
                    regex: /^(first|last) day of/i,
                    name: 'firstdayof | lastdayof',
                    callback: function callback(match, day) {
                        if (day.toLowerCase() === 'first') {
                            this.firstOrLastDayOfMonth = 1;
                        } else {
                            this.firstOrLastDayOfMonth = -1;
                        }
                    }
                },
                backOrFrontOf: {
                    regex: RegExp('^(back|front) of ' + reHour24 + reSpaceOpt + reMeridian + '?', 'i'),
                    name: 'backof | frontof',
                    callback: function callback(match, side, hours, meridian) {
                        var back = side.toLowerCase() === 'back';
                        var hour = +hours;
                        var minute = 15;
                        if (!back) {
                            hour -= 1;
                            minute = 45;
                        }
                        hour = processMeridian(hour, meridian);
                        return this.resetTime() && this.time(hour, minute, 0, 0);
                    }
                },
                weekdayOf: {
                    regex: RegExp('^(' + reReltextnumber + '|' + reReltexttext + ')' + reSpace + '(' + reDayfull + '|' + reDayabbr + ')' + reSpace + 'of', 'i'),
                    name: 'weekdayof'
                    // todo
                },
                mssqltime: {
                    regex: RegExp('^' + reHour12 + ':' + reMinutelz + ':' + reSecondlz + '[:.]([0-9]+)' + reMeridian, 'i'),
                    name: 'mssqltime',
                    callback: function callback(match, hour, minute, second, frac, meridian) {
                        return this.time(processMeridian(+hour, meridian), +minute, +second, +frac.substr(0, 3));
                    }
                },
                timeLong12: {
                    regex: RegExp('^' + reHour12 + '[:.]' + reMinute + '[:.]' + reSecondlz + reSpaceOpt + reMeridian, 'i'),
                    name: 'timelong12',
                    callback: function callback(match, hour, minute, second, meridian) {
                        return this.time(processMeridian(+hour, meridian), +minute, +second, 0);
                    }
                },
                timeShort12: {
                    regex: RegExp('^' + reHour12 + '[:.]' + reMinutelz + reSpaceOpt + reMeridian, 'i'),
                    name: 'timeshort12',
                    callback: function callback(match, hour, minute, meridian) {
                        return this.time(processMeridian(+hour, meridian), +minute, 0, 0);
                    }
                },
                timeTiny12: {
                    regex: RegExp('^' + reHour12 + reSpaceOpt + reMeridian, 'i'),
                    name: 'timetiny12',
                    callback: function callback(match, hour, meridian) {
                        return this.time(processMeridian(+hour, meridian), 0, 0, 0);
                    }
                },
                soap: {
                    regex: RegExp('^' + reYear4 + '-' + reMonthlz + '-' + reDaylz + 'T' + reHour24lz + ':' + reMinutelz + ':' + reSecondlz + reFrac + reTzCorrection + '?', 'i'),
                    name: 'soap',
                    callback: function callback(match, year, month, day, hour, minute, second, frac, tzCorrection) {
                        return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, +frac.substr(0, 3)) && this.zone(processTzCorrection(tzCorrection));
                    }
                },
                wddx: {
                    regex: RegExp('^' + reYear4 + '-' + reMonth + '-' + reDay + 'T' + reHour24 + ':' + reMinute + ':' + reSecond),
                    name: 'wddx',
                    callback: function callback(match, year, month, day, hour, minute, second) {
                        return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
                    }
                },
                exif: {
                    regex: RegExp('^' + reYear4 + ':' + reMonthlz + ':' + reDaylz + ' ' + reHour24lz + ':' + reMinutelz + ':' + reSecondlz, 'i'),
                    name: 'exif',
                    callback: function callback(match, year, month, day, hour, minute, second) {
                        return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
                    }
                },
                xmlRpc: {
                    regex: RegExp('^' + reYear4 + reMonthlz + reDaylz + 'T' + reHour24 + ':' + reMinutelz + ':' + reSecondlz),
                    name: 'xmlrpc',
                    callback: function callback(match, year, month, day, hour, minute, second) {
                        return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
                    }
                },
                xmlRpcNoColon: {
                    regex: RegExp('^' + reYear4 + reMonthlz + reDaylz + '[Tt]' + reHour24 + reMinutelz + reSecondlz),
                    name: 'xmlrpcnocolon',
                    callback: function callback(match, year, month, day, hour, minute, second) {
                        return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
                    }
                },
                clf: {
                    regex: RegExp('^' + reDay + '/(' + reMonthAbbr + ')/' + reYear4 + ':' + reHour24lz + ':' + reMinutelz + ':' + reSecondlz + reSpace + reTzCorrection, 'i'),
                    name: 'clf',
                    callback: function callback(match, day, month, year, hour, minute, second, tzCorrection) {
                        return this.ymd(+year, lookupMonth(month), +day) && this.time(+hour, +minute, +second, 0) && this.zone(processTzCorrection(tzCorrection));
                    }
                },
                iso8601long: {
                    regex: RegExp('^t?' + reHour24 + '[:.]' + reMinute + '[:.]' + reSecond + reFrac, 'i'),
                    name: 'iso8601long',
                    callback: function callback(match, hour, minute, second, frac) {
                        return this.time(+hour, +minute, +second, +frac.substr(0, 3));
                    }
                },
                dateTextual: {
                    regex: RegExp('^' + reMonthText + '[ .\\t-]*' + reDay + '[,.stndrh\\t ]+' + reYear, 'i'),
                    name: 'datetextual',
                    callback: function callback(match, month, day, year) {
                        return this.ymd(processYear(year), lookupMonth(month), +day);
                    }
                },
                pointedDate4: {
                    regex: RegExp('^' + reDay + '[.\\t-]' + reMonth + '[.-]' + reYear4),
                    name: 'pointeddate4',
                    callback: function callback(match, day, month, year) {
                        return this.ymd(+year, month - 1, +day);
                    }
                },
                pointedDate2: {
                    regex: RegExp('^' + reDay + '[.\\t]' + reMonth + '\\.' + reYear2),
                    name: 'pointeddate2',
                    callback: function callback(match, day, month, year) {
                        return this.ymd(processYear(year), month - 1, +day);
                    }
                },
                timeLong24: {
                    regex: RegExp('^t?' + reHour24 + '[:.]' + reMinute + '[:.]' + reSecond),
                    name: 'timelong24',
                    callback: function callback(match, hour, minute, second) {
                        return this.time(+hour, +minute, +second, 0);
                    }
                },
                dateNoColon: {
                    regex: RegExp('^' + reYear4 + reMonthlz + reDaylz),
                    name: 'datenocolon',
                    callback: function callback(match, year, month, day) {
                        return this.ymd(+year, month - 1, +day);
                    }
                },
                pgydotd: {
                    regex: RegExp('^' + reYear4 + '\\.?' + reDayOfYear),
                    name: 'pgydotd',
                    callback: function callback(match, year, day) {
                        return this.ymd(+year, 0, +day);
                    }
                },
                timeShort24: {
                    regex: RegExp('^t?' + reHour24 + '[:.]' + reMinute, 'i'),
                    name: 'timeshort24',
                    callback: function callback(match, hour, minute) {
                        return this.time(+hour, +minute, 0, 0);
                    }
                },
                iso8601noColon: {
                    regex: RegExp('^t?' + reHour24lz + reMinutelz + reSecondlz, 'i'),
                    name: 'iso8601nocolon',
                    callback: function callback(match, hour, minute, second) {
                        return this.time(+hour, +minute, +second, 0);
                    }
                },
                iso8601dateSlash: {
                    // eventhough the trailing slash is optional in PHP
                    // here it's mandatory and inputs without the slash
                    // are handled by dateslash
                    regex: RegExp('^' + reYear4 + '/' + reMonthlz + '/' + reDaylz + '/'),
                    name: 'iso8601dateslash',
                    callback: function callback(match, year, month, day) {
                        return this.ymd(+year, month - 1, +day);
                    }
                },
                dateSlash: {
                    regex: RegExp('^' + reYear4 + '/' + reMonth + '/' + reDay),
                    name: 'dateslash',
                    callback: function callback(match, year, month, day) {
                        return this.ymd(+year, month - 1, +day);
                    }
                },
                american: {
                    regex: RegExp('^' + reMonth + '/' + reDay + '/' + reYear),
                    name: 'american',
                    callback: function callback(match, month, day, year) {
                        return this.ymd(processYear(year), month - 1, +day);
                    }
                },
                americanShort: {
                    regex: RegExp('^' + reMonth + '/' + reDay),
                    name: 'americanshort',
                    callback: function callback(match, month, day) {
                        return this.ymd(this.y, month - 1, +day);
                    }
                },
                gnuDateShortOrIso8601date2: {
                    // iso8601date2 is complete subset of gnudateshort
                    regex: RegExp('^' + reYear + '-' + reMonth + '-' + reDay),
                    name: 'gnudateshort | iso8601date2',
                    callback: function callback(match, year, month, day) {
                        return this.ymd(processYear(year), month - 1, +day);
                    }
                },
                iso8601date4: {
                    regex: RegExp('^' + reYear4withSign + '-' + reMonthlz + '-' + reDaylz),
                    name: 'iso8601date4',
                    callback: function callback(match, year, month, day) {
                        return this.ymd(+year, month - 1, +day);
                    }
                },
                gnuNoColon: {
                    regex: RegExp('^t' + reHour24lz + reMinutelz, 'i'),
                    name: 'gnunocolon',
                    callback: function callback(match, hour, minute) {
                        return this.time(+hour, +minute, 0, this.f);
                    }
                },
                gnuDateShorter: {
                    regex: RegExp('^' + reYear4 + '-' + reMonth),
                    name: 'gnudateshorter',
                    callback: function callback(match, year, month) {
                        return this.ymd(+year, month - 1, 1);
                    }
                },
                pgTextReverse: {
                    // note: allowed years are from 32-9999
                    // years below 32 should be treated as days in datefull
                    regex: RegExp('^' + '(\\d{3,4}|[4-9]\\d|3[2-9])-(' + reMonthAbbr + ')-' + reDaylz, 'i'),
                    name: 'pgtextreverse',
                    callback: function callback(match, year, month, day) {
                        return this.ymd(processYear(year), lookupMonth(month), +day);
                    }
                },
                dateFull: {
                    regex: RegExp('^' + reDay + '[ \\t.-]*' + reMonthText + '[ \\t.-]*' + reYear, 'i'),
                    name: 'datefull',
                    callback: function callback(match, day, month, year) {
                        return this.ymd(processYear(year), lookupMonth(month), +day);
                    }
                },
                dateNoDay: {
                    regex: RegExp('^' + reMonthText + '[ .\\t-]*' + reYear4, 'i'),
                    name: 'datenoday',
                    callback: function callback(match, month, year) {
                        return this.ymd(+year, lookupMonth(month), 1);
                    }
                },
                dateNoDayRev: {
                    regex: RegExp('^' + reYear4 + '[ .\\t-]*' + reMonthText, 'i'),
                    name: 'datenodayrev',
                    callback: function callback(match, year, month) {
                        return this.ymd(+year, lookupMonth(month), 1);
                    }
                },
                pgTextShort: {
                    regex: RegExp('^(' + reMonthAbbr + ')-' + reDaylz + '-' + reYear, 'i'),
                    name: 'pgtextshort',
                    callback: function callback(match, month, day, year) {
                        return this.ymd(processYear(year), lookupMonth(month), +day);
                    }
                },
                dateNoYear: {
                    regex: RegExp('^' + reMonthText + '[ .\\t-]*' + reDay + '[,.stndrh\\t ]*', 'i'),
                    name: 'datenoyear',
                    callback: function callback(match, month, day) {
                        return this.ymd(this.y, lookupMonth(month), +day);
                    }
                },
                dateNoYearRev: {
                    regex: RegExp('^' + reDay + '[ .\\t-]*' + reMonthText, 'i'),
                    name: 'datenoyearrev',
                    callback: function callback(match, day, month) {
                        return this.ymd(this.y, lookupMonth(month), +day);
                    }
                },
                isoWeekDay: {
                    regex: RegExp('^' + reYear4 + '-?W' + reWeekOfYear + '(?:-?([0-7]))?'),
                    name: 'isoweekday | isoweek',
                    callback: function callback(match, year, week, day) {
                        day = day ? +day : 1;
                        if (!this.ymd(+year, 0, 1)) {
                            return false;
                        }
                        // get day of week for Jan 1st
                        var dayOfWeek = new Date(this.y, this.m, this.d).getDay();
                        // and use the day to figure out the offset for day 1 of week 1
                        dayOfWeek = 0 - (dayOfWeek > 4 ? dayOfWeek - 7 : dayOfWeek);
                        this.rd += dayOfWeek + (week - 1) * 7 + day;
                    }
                },
                relativeText: {
                    regex: RegExp('^(' + reReltextnumber + '|' + reReltexttext + ')' + reSpace + '(' + reReltextunit + ')', 'i'),
                    name: 'relativetext',
                    callback: function callback(match, relValue, relUnit) {
                        // todo: implement handling of 'this time-unit'
                        // eslint-disable-next-line no-unused-lets
                        var _a = lookupRelative(relValue),
                            amount = _a.amount,
                            behavior = _a.behavior;
                        switch (relUnit.toLowerCase()) {
                            case 'sec':
                            case 'secs':
                            case 'second':
                            case 'seconds':
                                this.rs += amount;
                                break;
                            case 'min':
                            case 'mins':
                            case 'minute':
                            case 'minutes':
                                this.ri += amount;
                                break;
                            case 'hour':
                            case 'hours':
                                this.rh += amount;
                                break;
                            case 'day':
                            case 'days':
                                this.rd += amount;
                                break;
                            case 'fortnight':
                            case 'fortnights':
                            case 'forthnight':
                            case 'forthnights':
                                this.rd += amount * 14;
                                break;
                            case 'week':
                            case 'weeks':
                                this.rd += amount * 7;
                                break;
                            case 'month':
                            case 'months':
                                this.rm += amount;
                                break;
                            case 'year':
                            case 'years':
                                this.ry += amount;
                                break;
                            case 'mon':
                            case 'monday':
                            case 'tue':
                            case 'tuesday':
                            case 'wed':
                            case 'wednesday':
                            case 'thu':
                            case 'thursday':
                            case 'fri':
                            case 'friday':
                            case 'sat':
                            case 'saturday':
                            case 'sun':
                            case 'sunday':
                                this.resetTime();
                                this.weekday = lookupWeekday(relUnit, 7);
                                this.weekdayBehavior = 1;
                                this.rd += (amount > 0 ? amount - 1 : amount) * 7;
                                break;
                            case 'weekday':
                            case 'weekdays':
                                // todo
                                break;
                        }
                    }
                },
                relative: {
                    regex: RegExp('^([+-]*)[ \\t]*(\\d+)' + reSpaceOpt + '(' + reReltextunit + '|week)', 'i'),
                    name: 'relative',
                    callback: function callback(match, signs, relValue, relUnit) {
                        var minuses = signs.replace(/[^-]/g, '').length;
                        var amount = +relValue * Math.pow(-1, minuses);
                        switch (relUnit.toLowerCase()) {
                            case 'sec':
                            case 'secs':
                            case 'second':
                            case 'seconds':
                                this.rs += amount;
                                break;
                            case 'min':
                            case 'mins':
                            case 'minute':
                            case 'minutes':
                                this.ri += amount;
                                break;
                            case 'hour':
                            case 'hours':
                                this.rh += amount;
                                break;
                            case 'day':
                            case 'days':
                                this.rd += amount;
                                break;
                            case 'fortnight':
                            case 'fortnights':
                            case 'forthnight':
                            case 'forthnights':
                                this.rd += amount * 14;
                                break;
                            case 'week':
                            case 'weeks':
                                this.rd += amount * 7;
                                break;
                            case 'month':
                            case 'months':
                                this.rm += amount;
                                break;
                            case 'year':
                            case 'years':
                                this.ry += amount;
                                break;
                            case 'mon':
                            case 'monday':
                            case 'tue':
                            case 'tuesday':
                            case 'wed':
                            case 'wednesday':
                            case 'thu':
                            case 'thursday':
                            case 'fri':
                            case 'friday':
                            case 'sat':
                            case 'saturday':
                            case 'sun':
                            case 'sunday':
                                this.resetTime();
                                this.weekday = lookupWeekday(relUnit, 7);
                                this.weekdayBehavior = 1;
                                this.rd += (amount > 0 ? amount - 1 : amount) * 7;
                                break;
                            case 'weekday':
                            case 'weekdays':
                                // todo
                                break;
                        }
                    }
                },
                dayText: {
                    regex: RegExp('^(' + reDaytext + ')', 'i'),
                    name: 'daytext',
                    callback: function callback(match, dayText) {
                        this.resetTime();
                        this.weekday = lookupWeekday(dayText, 0);
                        if (this.weekdayBehavior !== 2) {
                            this.weekdayBehavior = 1;
                        }
                    }
                },
                relativeTextWeek: {
                    regex: RegExp('^(' + reReltexttext + ')' + reSpace + 'week', 'i'),
                    name: 'relativetextweek',
                    callback: function callback(match, relText) {
                        this.weekdayBehavior = 2;
                        switch (relText.toLowerCase()) {
                            case 'this':
                                this.rd += 0;
                                break;
                            case 'next':
                                this.rd += 7;
                                break;
                            case 'last':
                            case 'previous':
                                this.rd -= 7;
                                break;
                        }
                        if (isNaN(this.weekday)) {
                            this.weekday = 1;
                        }
                    }
                },
                monthFullOrMonthAbbr: {
                    regex: RegExp('^(' + reMonthFull + '|' + reMonthAbbr + ')', 'i'),
                    name: 'monthfull | monthabbr',
                    callback: function callback(match, month) {
                        return this.ymd(this.y, lookupMonth(month), this.d);
                    }
                },
                tzCorrection: {
                    regex: RegExp('^' + reTzCorrection, 'i'),
                    name: 'tzcorrection',
                    callback: function callback(tzCorrection) {
                        return this.zone(processTzCorrection(tzCorrection));
                    }
                },
                ago: {
                    regex: /^ago/i,
                    name: 'ago',
                    callback: function callback() {
                        this.ry = -this.ry;
                        this.rm = -this.rm;
                        this.rd = -this.rd;
                        this.rh = -this.rh;
                        this.ri = -this.ri;
                        this.rs = -this.rs;
                        this.rf = -this.rf;
                    }
                },
                gnuNoColon2: {
                    // second instance of gnunocolon, without leading 't'
                    // it's down here, because it is very generic (4 digits in a row)
                    // thus conflicts with many rules above
                    // only year4 should come afterwards
                    regex: RegExp('^' + reHour24lz + reMinutelz, 'i'),
                    name: 'gnunocolon',
                    callback: function callback(match, hour, minute) {
                        return this.time(+hour, +minute, 0, this.f);
                    }
                },
                year4: {
                    regex: RegExp('^' + reYear4),
                    name: 'year4',
                    callback: function callback(match, year) {
                        this.y = +year;
                        return true;
                    }
                },
                whitespace: {
                    regex: /^[ .,\t]+/,
                    name: 'whitespace'
                    // do nothing
                },
                any: {
                    regex: /^[\s\S]+/,
                    name: 'any',
                    callback: function callback() {
                        return false;
                    }
                }
            };
            var resultProto = {
                // date
                y: NaN,
                m: NaN,
                d: NaN,
                // time
                h: NaN,
                i: NaN,
                s: NaN,
                f: NaN,
                // relative shifts
                ry: 0,
                rm: 0,
                rd: 0,
                rh: 0,
                ri: 0,
                rs: 0,
                rf: 0,
                // weekday related shifts
                weekday: NaN,
                weekdayBehavior: 0,
                // first or last day of month
                // 0 none, 1 first, -1 last
                firstOrLastDayOfMonth: 0,
                // timezone correction in minutes
                z: NaN,
                // counters
                dates: 0,
                times: 0,
                zones: 0,
                // helper functions
                ymd: function ymd(y, m, d) {
                    if (this.dates > 0) {
                        return false;
                    }
                    this.dates++;
                    this.y = y;
                    this.m = m;
                    this.d = d;
                    return true;
                },
                time: function time(h, i, s, f) {
                    if (this.times > 0) {
                        return false;
                    }
                    this.times++;
                    this.h = h;
                    this.i = i;
                    this.s = s;
                    this.f = f;
                    return true;
                },
                resetTime: function resetTime() {
                    this.h = 0;
                    this.i = 0;
                    this.s = 0;
                    this.f = 0;
                    this.times = 0;
                    return true;
                },
                zone: function zone(minutes) {
                    if (this.zones <= 1) {
                        this.zones++;
                        this.z = minutes;
                        return true;
                    }
                    return false;
                },
                toDate: function toDate(relativeTo) {
                    if (this.dates && !this.times) {
                        this.h = this.i = this.s = this.f = 0;
                    }
                    // fill holes
                    if (isNaN(this.y)) {
                        this.y = relativeTo.getFullYear();
                    }
                    if (isNaN(this.m)) {
                        this.m = relativeTo.getMonth();
                    }
                    if (isNaN(this.d)) {
                        this.d = relativeTo.getDate();
                    }
                    if (isNaN(this.h)) {
                        this.h = relativeTo.getHours();
                    }
                    if (isNaN(this.i)) {
                        this.i = relativeTo.getMinutes();
                    }
                    if (isNaN(this.s)) {
                        this.s = relativeTo.getSeconds();
                    }
                    if (isNaN(this.f)) {
                        this.f = relativeTo.getMilliseconds();
                    }
                    // adjust special early
                    switch (this.firstOrLastDayOfMonth) {
                        case 1:
                            this.d = 1;
                            break;
                        case -1:
                            this.d = 0;
                            this.m += 1;
                            break;
                    }
                    if (!isNaN(this.weekday)) {
                        var date_1 = new Date(relativeTo.getTime());
                        date_1.setFullYear(this.y, this.m, this.d);
                        date_1.setHours(this.h, this.i, this.s, this.f);
                        var dow = date_1.getDay();
                        if (this.weekdayBehavior === 2) {
                            // To make "this week" work, where the current day of week is a "sunday"
                            if (dow === 0 && this.weekday !== 0) {
                                this.weekday = -6;
                            }
                            // To make "sunday this week" work, where the current day of week is not a "sunday"
                            if (this.weekday === 0 && dow !== 0) {
                                this.weekday = 7;
                            }
                            this.d -= dow;
                            this.d += this.weekday;
                        } else {
                            var diff = this.weekday - dow;
                            // some PHP magic
                            if (this.rd < 0 && diff < 0 || this.rd >= 0 && diff <= -this.weekdayBehavior) {
                                diff += 7;
                            }
                            if (this.weekday >= 0) {
                                this.d += diff;
                            } else {
                                this.d -= 7 - (Math.abs(this.weekday) - dow);
                            }
                            this.weekday = NaN;
                        }
                    }
                    // adjust relative
                    this.y += this.ry;
                    this.m += this.rm;
                    this.d += this.rd;
                    this.h += this.rh;
                    this.i += this.ri;
                    this.s += this.rs;
                    this.f += this.rf;
                    this.ry = this.rm = this.rd = 0;
                    this.rh = this.ri = this.rs = this.rf = 0;
                    var result = new Date(relativeTo.getTime());
                    // since Date letructor treats years <= 99 as 1900+
                    // it can't be used, thus this weird way
                    result.setFullYear(this.y, this.m, this.d);
                    result.setHours(this.h, this.i, this.s, this.f);
                    // note: this is done twice in PHP
                    // early when processing special relatives
                    // and late
                    // todo: check if the logic can be reduced
                    // to just one time action
                    switch (this.firstOrLastDayOfMonth) {
                        case 1:
                            result.setDate(1);
                            break;
                        case -1:
                            result.setMonth(result.getMonth() + 1, 0);
                            break;
                    }
                    // adjust timezone
                    if (!isNaN(this.z) && result.getTimezoneOffset() !== this.z) {
                        result.setUTCFullYear(result.getFullYear(), result.getMonth(), result.getDate());
                        result.setUTCHours(result.getHours(), result.getMinutes() + this.z, result.getSeconds(), result.getMilliseconds());
                    }
                    return result;
                }
            };
            var resultFn = function resultFn(str, now) {
                //       discuss at: http://locutus.io/php/strtotime/
                //      original by: Caio Ariede (http://caioariede.com)
                //      improved by: Kevin van Zonneveld (http://kvz.io)
                //      improved by: Caio Ariede (http://caioariede.com)
                //      improved by: A. Matías Quezada (http://amatiasq.com)
                //      improved by: preuter
                //      improved by: Brett Zamir (http://brett-zamir.me)
                //      improved by: Mirko Faber
                //         input by: David
                //      bugfixed by: Wagner B. Soares
                //      bugfixed by: Artur Tchernychev
                //      bugfixed by: Stephan Bösch-Plepelits (http://github.com/plepe)
                // reimplemented by: Rafał Kukawski
                //           note 1: Examples all have a fixed timestamp to prevent
                //           note 1: tests to fail because of letiable time(zones)
                //        example 1: strtotime('+1 day', 1129633200)
                //        returns 1: 1129719600
                //        example 2: strtotime('+1 week 2 days 4 hours 2 seconds', 1129633200)
                //        returns 2: 1130425202
                //        example 3: strtotime('last month', 1129633200)
                //        returns 3: 1127041200
                //        example 4: strtotime('2009-05-04 08:30:00+00')
                //        returns 4: 1241425800
                //        example 5: strtotime('2009-05-04 08:30:00+02:00')
                //        returns 5: 1241418600
                if (now == null) {
                    now = Math.floor(Date.now() / 1000);
                }
                // the rule order is very fragile
                // as many formats are similar to others
                // so small change can cause
                // input misinterpretation
                var rules = [formats.yesterday, formats.now, formats.noon, formats.midnightOrToday, formats.tomorrow, formats.timestamp, formats.firstOrLastDay, formats.backOrFrontOf,
                    // formats.weekdayOf, // not yet implemented
                    formats.mssqltime, formats.timeLong12, formats.timeShort12, formats.timeTiny12, formats.soap, formats.wddx, formats.exif, formats.xmlRpc, formats.xmlRpcNoColon, formats.clf, formats.iso8601long, formats.dateTextual, formats.pointedDate4, formats.pointedDate2, formats.timeLong24, formats.dateNoColon, formats.pgydotd, formats.timeShort24, formats.iso8601noColon,
                    // iso8601dateSlash needs to come before dateSlash
                    formats.iso8601dateSlash, formats.dateSlash, formats.american, formats.americanShort, formats.gnuDateShortOrIso8601date2, formats.iso8601date4, formats.gnuNoColon, formats.gnuDateShorter, formats.pgTextReverse, formats.dateFull, formats.dateNoDay, formats.dateNoDayRev, formats.pgTextShort, formats.dateNoYear, formats.dateNoYearRev, formats.isoWeekDay, formats.relativeText, formats.relative, formats.dayText, formats.relativeTextWeek, formats.monthFullOrMonthAbbr, formats.tzCorrection, formats.ago, formats.gnuNoColon2, formats.year4,
                    // note: the two rules below
                    // should always come last
                    formats.whitespace, formats.any];
                var result = Object.create(resultProto);
                while (str.length) {
                    for (var i = 0, l = rules.length; i < l; i++) {
                        var format = rules[i];
                        var match = str.match(format.regex);
                        if (match) {
                            // care only about false results. Ignore other values
                            if (format.callback && format.callback.apply(result, match) === false) {
                                return false;
                            }
                            str = str.substr(match[0].length);
                            break;
                        }
                    }
                }
                return Math.floor(result.toDate(new Date(now * 1000)) / 1000);
            };
            return resultFn(str, now);
        },
        /**
         * 返回指定长度的月份集合
         *
         * @param  {time} 时间
         * @param  {len} 长度
         * @param  {direction} 方向：  1: 前几个月;  2: 后几个月;  3:前后几个月  默认 3
         * @return {Array} 数组
         *
         * @example   getMonths('2018-1-29', 6, 1)  // ->  ["2018-1", "2017-12", "2017-11", "2017-10", "2017-9", "2017-8", "2017-7"]
         */
        getMonths(time, len, direction) {
            var mm = new Date(time).getMonth(),
                yy = new Date(time).getFullYear(),
                direction = isNaN(direction) ? 3 : direction,
                index = mm;
            var cutMonth = function(index) {
                if ( index <= len && index >= -len) {
                    return direction === 1 ? formatPre(index).concat(cutMonth(++index)):
                        direction === 2 ? formatNext(index).concat(cutMonth(++index)):formatCurr(index).concat(cutMonth(++index))
                }
                return []
            }
            var formatNext = function(i) {
                var y = Math.floor(i/12),
                    m = i%12
                return [yy+y + '-' + (m+1)]
            }
            var formatPre = function(i) {
                var y = Math.ceil(i/12),
                    m = i%12
                m = m===0 ? 12 : m
                return [yy-y + '-' + (13 - m)]
            }
            var formatCurr = function(i) {
                var y = Math.floor(i/12),
                    yNext = Math.ceil(i/12),
                    m = i%12,
                    mNext = m===0 ? 12 : m
                return [yy-yNext + '-' + (13 - mNext),yy+y + '-' + (m+1)]
            }
            // 数组去重
            var unique = function(arr) {
                if ( Array.hasOwnProperty('from') ) {
                    return Array.from(new Set(arr));
                }else{
                    var n = {},r=[];
                    for(var i = 0; i < arr.length; i++){
                        if (!n[arr[i]]){
                            n[arr[i]] = true;
                            r.push(arr[i]);
                        }
                    }
                    return r;
                }
            }
            return direction !== 3 ? cutMonth(index) : unique(cutMonth(index).sort(function(t1, t2){
                return new Date(t1).getTime() - new Date(t2).getTime()
            }))
        },

        /**
         * 返回指定长度的天数集合
         *
         * @param  {time} 时间
         * @param  {len} 长度
         * @param  {direction} 方向： 1: 前几天;  2: 后几天;  3:前后几天  默认 3
         * @return {Array} 数组
         *
         * @example date.getDays('2018-1-29', 6) // -> ["2018-1-26", "2018-1-27", "2018-1-28", "2018-1-29", "2018-1-30", "2018-1-31", "2018-2-1"]
         */
        getDays(time, len, diretion) {
            var tt = new Date(time)
            var getDay = function(day) {
                var t = new Date(time)
                t.setDate(t.getDate() + day)
                var m = t.getMonth()+1
                return t.getFullYear()+'-'+m+'-'+t.getDate()
            }
            var arr = []
            if (diretion === 1) {
                for (var i = 1; i <= len; i++) {
                    arr.unshift(getDay(-i))
                }
            }else if(diretion === 2) {
                for (var i = 1; i <= len; i++) {
                    arr.push(getDay(i))
                }
            }else {
                for (var i = 1; i <= len; i++) {
                    arr.unshift(getDay(-i))
                }
                arr.push(tt.getFullYear()+'-'+(tt.getMonth()+1)+'-'+tt.getDate())
                for (var i = 1; i <= len; i++) {
                    arr.push(getDay(i))
                }
            }
            return diretion === 1 ? arr.concat([tt.getFullYear()+'-'+(tt.getMonth()+1)+'-'+tt.getDate()]) :
                diretion === 2 ? [tt.getFullYear()+'-'+(tt.getMonth()+1)+'-'+tt.getDate()].concat(arr) : arr
        },


        /**
         * @return {String} 字符串
         *
         * @example formatHMS(3610) // -> 1h0m10s
         * @param s
         */
        formatHMS (s) {
            var str = ''
            if (s > 3600) {
                str = Math.floor(s/3600)+'h'+Math.floor(s%3600/60)+'m'+s%60+'s'
            }else if(s > 60) {
                str = Math.floor(s/60)+'m'+s%60+'s'
            }else{
                str = s%60+'s'
            }
            return str
        },

        /**
         * 获取某月有多少天
         * @param time
         * @returns {number}
         */
        getMonthOfDay (time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var mouth = date.getMonth() + 1;
            var days;

            //当月份为二月时，根据闰年还是非闰年判断天数
            if (mouth == 2) {
                days = (year%4==0 && year%100==0 && year%400==0) || (year%4==0 && year%100!=0) ? 28 : 29
            } else if (mouth == 1 || mouth == 3 || mouth == 5 || mouth == 7 || mouth == 8 || mouth == 10 || mouth == 12) {
                //月份为：1,3,5,7,8,10,12 时，为大月.则天数为31；
                days = 31
            } else {
                //其他月份，天数为：30.
                days = 30
            }
            return days
        },

        /**
         * 获取某年有多少天
         * @param time
         * @returns {number}
         */
        getYearOfDay (time) {
            var firstDayYear = this.getFirstDayOfYear(time);
            var lastDayYear = this.getLastDayOfYear(time);
            var numSecond = (new Date(lastDayYear).getTime() - new Date(firstDayYear).getTime())/1000;
            return Math.ceil(numSecond/(24*3600));
        },

        /**
         * 获取某年的第一天
         * @param time
         * @returns {string}
         */
        getFirstDayOfYear (time) {
            var year = new Date(time).getFullYear();
            return year + "-01-01 00:00:00";
        },

        /**
         * 获取某年最后一天
         * @param time
         * @returns {string}
         */
        getLastDayOfYear (time) {
            var year = new Date(time).getFullYear();
            var dateString = year + "-12-01 00:00:00";
            var endDay = this.getMonthOfDay(dateString);
            return year + "-12-" + endDay + " 23:59:59";
        },
        /**
         * 获取某个日期是当年中的第几天
         * @param time
         * @returns {number}
         */
        getDayOfYear (time) {
            var firstDayYear = this.getFirstDayOfYear(time);
            var numSecond = (new Date(time).getTime() - new Date(firstDayYear).getTime())/1000;
            return Math.ceil(numSecond/(24*3600));
        },

        /**
         * 获取某个日期在这一年的第几周
         * @param time
         * @returns {number}
         */
        getDayOfYearWeek (time) {
            var numdays = this.getDayOfYear(time);
            return Math.ceil(numdays / 7);
        }
    },
    array:{
        inArray (arr, val) {
            return arr.indexOf(val) != -1 ? true : false;
        },
        /*判断一个元素是否在数组中*/
        contains (arr, val) {
            return arr.indexOf(val) != -1 ? true : false;
        },

        /**
         * @param  {arr} 数组
         * @param  {fn} 回调函数
         * @return {undefined}
         */
        each (arr, fn) {
            fn = fn || Function;
            var a = [];
            var args = Array.prototype.slice.call(arguments, 1);
            for(var i = 0; i < arr.length; i++) {
                var res = fn.apply(arr, [arr[i], i].concat(args));
                if(res != null) a.push(res);
            }
        },

        /**
         * @param  {arr} 数组
         * @param  {fn} 回调函数
         * @param  {thisObj} this指向
         * @return {Array}
         */
        map (arr, fn, thisObj) {
            var scope = thisObj || window;
            var a = [];
            for(var i = 0, j = arr.length; i < j; ++i) {
                var res = fn.call(scope, arr[i], i, this);
                if(res != null) a.push(res);
            }
            return a;
        },

        /**
         * @param  {arr} 数组
         * @param  {type} 1：从小到大   2：从大到小   3：随机
         * @return {Array}
         */
        sort (arr, type = 1) {
            return arr.sort( (a, b) => {
                switch(type) {
                    case 1:
                        return a - b;
                    case 2:
                        return b - a;
                    case 3:
                        return Math.random() - 0.5;
                    default:
                        return arr;
                }
            })
        },

        /*去重*/
        unique (arr) {
            if ( Array.hasOwnProperty('from') ) {
                return Array.from(new Set(arr))
            }else{
                var r = [], NaNBol = true
                for(var i=0; i < arr.length; i++) {
                    if (arr[i] !== arr[i]) {
                        if (NaNBol && r.indexOf(arr[i]) === -1) {
                            r.push(arr[i])
                            NaNBol = false
                        }
                    }else{
                        if(r.indexOf(arr[i]) === -1) r.push(arr[i])
                    }
                }
                return r
            }
        },

        /*求两个集合的并集*/
        union (a, b) {
            var newArr = a.concat(b);
            return this.unique(newArr);
        },

        /*求两个集合的交集*/
        intersect (a, b) {
            var _this = this;
            a = this.unique(a);
            return this.map(a, function(o) {
                return _this.contains(b, o) ? o : null;
            });
        },

        /*删除其中一个元素*/
        remove (arr, ele) {
            var index = arr.indexOf(ele);
            if(index > -1) {
                arr.splice(index, 1);
            }
            return arr;
        },

        /*将类数组转换为数组的方法*/
        formArray (ary) {
            var arr = [];
            if(Array.isArray(ary)) {
                arr = ary;
            } else {
                arr = Array.prototype.slice.call(ary);
            }
            return arr;
        },

        /*最大值*/
        max (arr) {
            return Math.max.apply(null, arr);
        },

        /*最小值*/
        min (arr) {
            return Math.min.apply(null, arr);
        },

        /*求和*/
        sum (arr) {
            return arr.reduce( (pre, cur) => {
                return pre + cur
            })
        },

        /*平均值*/
        average (arr) {
            return this.sum(arr)/arr.length
        }
    },
    string:{
        /**
         * 去除空格
         * @param str
         * @param type
         * @returns {void|string|*}
         */
        trim (str, type = 1) {
            switch (type) {
                case 1:
                    return str.replace(/\s+/g, "");
                case 2:
                    return str.replace(/(^\s*)|(\s*$)/g, "");
                case 3:
                    return str.replace(/(^\s*)/g, "");
                case 4:
                    return str.replace(/(\s*$)/g, "");
                default:
                    return str;
            }
        },

        /**
         * 大小写转换
         * @param str
         * @param type  1:首字母大写  2：首页母小写  3：大小写转换  4：全部大写  5：全部小写
         * @returns {string|void|*}
         */
        changeCase (str, type = 4) {
            switch (type) {
                case 1:
                    return str.replace(/\b\w+\b/g, function (word) {
                        return word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase();

                    });
                case 2:
                    return str.replace(/\b\w+\b/g, function (word) {
                        return word.substring(0, 1).toLowerCase() + word.substring(1).toUpperCase();
                    });
                case 3:
                    return str.split('').map( function(word){
                        if (/[a-z]/.test(word)) {
                            return word.toUpperCase();
                        }else{
                            return word.toLowerCase()
                        }
                    }).join('');
                case 4:
                    return str.toUpperCase();
                case 5:
                    return str.toLowerCase();
                default:
                    return str;
            }
        },


        /**
         * 检测密码强度
         * @param str
         * @returns {number}
         */
        checkPwd (str) {
            var Lv = 0;
            if (str.length < 6) {
                return Lv
            }
            if (/[0-9]/.test(str)) {
                Lv++
            }
            if (/[a-z]/.test(str)) {
                Lv++
            }
            if (/[A-Z]/.test(str)) {
                Lv++
            }
            if (/[\.|-|_]/.test(str)) {
                Lv++
            }
            return Lv;
        },

        /**
         * 过滤html代码
         * @param str
         * @returns {string}
         */
        filterTag (str) {
            str = str.replace(/&/ig, "&amp;");
            str = str.replace(/</ig, "&lt;");
            str = str.replace(/>/ig, "&gt;");
            str = str.replace(" ", "&nbsp;");
            return str;
        }
    },
    number:{
        /**
         * 随机数范围
         * @param min
         * @param max
         * @returns {null|number}
         */
        random (min, max) {
            if (arguments.length === 2) {
                return Math.floor(min + Math.random() * ( (max+1) - min ))
            }else{
                return null;
            }
        },
        /**
         * 不足位补齐
         * @param num
         * @param n
         * @returns {*|*}
         */
        makeNumber(num, n = 0) {
            var tbl = [];
            var thumb = function thumb() {
                var len = n - num.toString().length;
                if (len <= 0) return num;
                if (!tbl[len]) tbl[len] = new Array(len + 1).join('0');
                return tbl[len] + num;
            };
            return thumb(num.n);
        },
        /**
         * 将阿拉伯数字翻译成中文的大写数字
         * @param num
         * @returns {string}
         */
        numberToChinese (num) {
            var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十");
            var BB = new Array("", "十", "百", "仟", "萬", "億", "点", "");
            var a = ("" + num).replace(/(^0*)/g, "").split("."),
                k = 0,
                re = "";
            for(var i = a[0].length - 1; i >= 0; i--) {
                switch(k) {
                    case 0:
                        re = BB[7] + re;
                        break;
                    case 4:
                        if(!new RegExp("0{4}//d{" + (a[0].length - i - 1) + "}$")
                            .test(a[0]))
                            re = BB[4] + re;
                        break;
                    case 8:
                        re = BB[5] + re;
                        BB[7] = BB[5];
                        k = 0;
                        break;
                }
                if(k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0)
                    re = AA[0] + re;
                if(a[0].charAt(i) != 0)
                    re = AA[a[0].charAt(i)] + BB[k % 4] + re;
                k++;
            }

            if(a.length > 1) // 加上小数部分(如果有小数部分)
            {
                re += BB[6];
                for(var i = 0; i < a[1].length; i++)
                    re += AA[a[1].charAt(i)];
            }
            if(re == '一十')
                re = "十";
            if(re.match(/^一/) && re.length == 3)
                re = re.replace("一", "");
            return re;
        },

        /**
         * 将数字转换为大写金额
         * @param Num
         * @returns {string}
         */
        changeToChinese (Num) {
            //判断如果传递进来的不是字符的话转换为字符
            if(typeof Num == "number") {
                Num = new String(Num);
            }
            Num = Num.replace(/,/g, "") //替换tomoney()中的“,”
            Num = Num.replace(/ /g, "") //替换tomoney()中的空格
            Num = Num.replace(/￥/g, "") //替换掉可能出现的￥字符
            if(isNaN(Num)) { //验证输入的字符是否为数字
                //alert("请检查小写金额是否正确");
                return "";
            }
            //字符处理完毕后开始转换，采用前后两部分分别转换
            var part = String(Num).split(".");
            var newchar = "";
            //小数点前进行转化
            for(var i = part[0].length - 1; i >= 0; i--) {
                if(part[0].length > 10) {
                    return "";
                    //若数量超过拾亿单位，提示
                }
                var tmpnewchar = "";
                var perchar = part[0].charAt(i);
                switch(perchar) {
                    case "0":
                        tmpnewchar = "零" + tmpnewchar;
                        break;
                    case "1":
                        tmpnewchar = "壹" + tmpnewchar;
                        break;
                    case "2":
                        tmpnewchar = "贰" + tmpnewchar;
                        break;
                    case "3":
                        tmpnewchar = "叁" + tmpnewchar;
                        break;
                    case "4":
                        tmpnewchar = "肆" + tmpnewchar;
                        break;
                    case "5":
                        tmpnewchar = "伍" + tmpnewchar;
                        break;
                    case "6":
                        tmpnewchar = "陆" + tmpnewchar;
                        break;
                    case "7":
                        tmpnewchar = "柒" + tmpnewchar;
                        break;
                    case "8":
                        tmpnewchar = "捌" + tmpnewchar;
                        break;
                    case "9":
                        tmpnewchar = "玖" + tmpnewchar;
                        break;
                }
                switch(part[0].length - i - 1) {
                    case 0:
                        tmpnewchar = tmpnewchar + "元";
                        break;
                    case 1:
                        if(perchar != 0) tmpnewchar = tmpnewchar + "拾";
                        break;
                    case 2:
                        if(perchar != 0) tmpnewchar = tmpnewchar + "佰";
                        break;
                    case 3:
                        if(perchar != 0) tmpnewchar = tmpnewchar + "仟";
                        break;
                    case 4:
                        tmpnewchar = tmpnewchar + "万";
                        break;
                    case 5:
                        if(perchar != 0) tmpnewchar = tmpnewchar + "拾";
                        break;
                    case 6:
                        if(perchar != 0) tmpnewchar = tmpnewchar + "佰";
                        break;
                    case 7:
                        if(perchar != 0) tmpnewchar = tmpnewchar + "仟";
                        break;
                    case 8:
                        tmpnewchar = tmpnewchar + "亿";
                        break;
                    case 9:
                        tmpnewchar = tmpnewchar + "拾";
                        break;
                }
                var newchar = tmpnewchar + newchar;
            }
            //小数点之后进行转化
            if(Num.indexOf(".") != -1) {
                if(part[1].length > 2) {
                    // alert("小数点之后只能保留两位,系统将自动截断");
                    part[1] = part[1].substr(0, 2)
                }
                for(i = 0; i < part[1].length; i++) {
                    tmpnewchar = ""
                    perchar = part[1].charAt(i)
                    switch(perchar) {
                        case "0":
                            tmpnewchar = "零" + tmpnewchar;
                            break;
                        case "1":
                            tmpnewchar = "壹" + tmpnewchar;
                            break;
                        case "2":
                            tmpnewchar = "贰" + tmpnewchar;
                            break;
                        case "3":
                            tmpnewchar = "叁" + tmpnewchar;
                            break;
                        case "4":
                            tmpnewchar = "肆" + tmpnewchar;
                            break;
                        case "5":
                            tmpnewchar = "伍" + tmpnewchar;
                            break;
                        case "6":
                            tmpnewchar = "陆" + tmpnewchar;
                            break;
                        case "7":
                            tmpnewchar = "柒" + tmpnewchar;
                            break;
                        case "8":
                            tmpnewchar = "捌" + tmpnewchar;
                            break;
                        case "9":
                            tmpnewchar = "玖" + tmpnewchar;
                            break;
                    }
                    if(i == 0) tmpnewchar = tmpnewchar + "角";
                    if(i == 1) tmpnewchar = tmpnewchar + "分";
                    newchar = newchar + tmpnewchar;
                }
            }
            //替换所有无用汉字
            while(newchar.search("零零") != -1)
                newchar = newchar.replace("零零", "零");
            newchar = newchar.replace("零亿", "亿");
            newchar = newchar.replace("亿万", "亿");
            newchar = newchar.replace("零万", "万");
            newchar = newchar.replace("零元", "元");
            newchar = newchar.replace("零角", "");
            newchar = newchar.replace("零分", "");
            if(newchar.charAt(newchar.length - 1) == "元") {
                newchar = newchar + "整"
            }
            return newchar;
        }
    },
    other:{
        /**
         * [deepClone 深度克隆]
         * @param  {[type]} obj [克隆对象]
         * @return {[type]}     [返回深度克隆后的对象]
         */
        deepClone (obj) {
            if (obj === null || typeof obj !== 'object') return obj
            var isType = function(obj, type) {
                var flag,
                    typeString = Object.prototype.toString.call(obj)
                switch(type) {
                    case 'Array':
                        flag = typeString === '[object Array]'
                        break
                    case 'Date':
                        flag = typeString === '[object Date]'
                        break
                    case 'RegExp':
                        flag = typeString === '[object RegExp]'
                        break
                    default:
                        flag = false
                }
                return flag
            }
            var getRegExp = function(re) {
                var flags = ''
                if (re.global) flags += 'g'
                if (re.ignoreCase) flags += 'i'
                if (re.multiline) flags += 'm'
                return flags
            }

            var _clone = function(parent) {
                var child, proto, parents = [], children = []
                if (isType(parent, 'Array')) {// 对数组做特殊处理
                    child = [];
                } else if (isType(parent, 'RegExp')) {// 对正则做特殊处理
                    child = new RegExp(parent.source, getRegExp(parent));
                    if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                } else if (isType(parent, 'Date')) {// 对Date做特殊处理
                    child = new Date(parent.getTime());
                } else {
                    // 处理对象原型
                    proto = Object.getPrototypeOf(parent);
                    // 利用Object.create切断原型链
                    child = Object.create(proto);
                }
                // 处理循环引用
                var index = parents.indexOf(parent);

                if (index != -1) {
                    // 如果父数组存在本对象,说明之前已经被引用过,直接返回此对象
                    return children[index];
                }
                parents.push(parent);
                children.push(child);

                for (var i in parent) {
                    child[i] = _clone(parent[i]);
                }

                return child;
            }
            return _clone(obj)
        },

        /*获取网址参数*/
        getUrlParams(name){
            var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
            var r = decodeURI(window.location.search).substr(1).match(reg);
            if(r!=null) return  r[2]; return null;
        },

        /**
         * 设置url参数
         * @param url  目标地址
         * @param arg  参数名
         * @param arg_val  参数值
         * @returns {string}
         */
        setParam(url, arg, arg_val) {
            var pattern = arg + '=([^&]*)';
            var replaceText = arg + '=' + arg_val;
            if (url.match(pattern)) {
                var tmp = '/(' + arg + '=)([^&]*)/gi';
                tmp = url.replace(eval(tmp), replaceText);
                return tmp;
            } else {
                if (url.match('[\?]')) {
                    return url + '&' + replaceText;
                } else {
                    return url + '?' + replaceText;
                }
            }
            return url + '\n' + arg + '\n' + arg_val;
        },

        /*获取全部url参数,并转换成json对象*/
        getUrlAllParams (url) {
            var url = url ? url : window.location.href;
            var _pa = url.substring(url.indexOf('?') + 1),
                _arrS = _pa.split('&'),
                _rs = {};
            for (var i = 0, _len = _arrS.length; i < _len; i++) {
                var pos = _arrS[i].indexOf('=');
                if (pos == -1) {
                    continue;
                }
                var name = _arrS[i].substring(0, pos),
                    value = window.decodeURIComponent(_arrS[i].substring(pos + 1));
                _rs[name] = value;
            }
            return _rs;
        },
        /**
         * 对象转url参数
         * @param param
         * @param key
         * @param encode
         */
        urlEncode(param, key, encode) {
            if (param==null) return '';
            var paramStr = '';
            var t = typeof (param);
            if (t == 'string' || t == 'number' || t == 'boolean') {
                paramStr += '&' + key + '='  + ((encode==null||encode) ? encodeURIComponent(param) : param);
            } else {
                for (var i in param) {
                    var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
                    paramStr += urlEncode(param[i], k, encode)
                }
            }
            return paramStr;
        },

        /*删除url指定参数，返回url*/
        delParamsUrl(url, name){
            var baseUrl = url.split('?')[0] + '?';
            var query = url.split('?')[1];
            if (query.indexOf(name)>-1) {
                var obj = {}
                var arr = query.split("&");
                for (var i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].split("=");
                    obj[arr[i][0]] = arr[i][1];
                };
                delete obj[name];
                var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
                return url
            }else{
                return url;
            }
        },

        /*获取十六进制随机颜色*/
        getRandomColor () {
            return '#' + (function(h) {
                return new Array(7 - h.length).join("0") + h;
            })((Math.random() * 0x1000000 << 0).toString(16));
        },

        /*图片加载*/
        imgLoadAll(arr,callback){
            var arrImg = [];
            for (var i = 0; i < arr.length; i++) {
                var img = new Image();
                img.src = arr[i];
                img.onload = function(){
                    arrImg.push(this);
                    if (arrImg.length == arr.length) {
                        callback && callback();
                    }
                }
            }
        },

        /*音频加载*/
        loadAudio(src, callback) {
            var audio = new Audio(src);
            audio.onloadedmetadata = callback;
            audio.src = src;
        },

        /*DOM转字符串*/
        domToStirng(htmlDOM){
            var div= document.createElement("div");
            div.appendChild(htmlDOM);
            return div.innerHTML
        },

        /*字符串转DOM*/
        stringToDom(htmlString){
            var div= document.createElement("div");
            div.innerHTML=htmlString;
            return div.children[0];
        },
        /**
         * 光标所在位置插入字符，并设置光标位置
         *
         * @param {dom} 输入框
         * @param {val} 插入的值
         * @param {posLen} 光标位置处在 插入的值的哪个位置
         */
        setCursorPosition (dom,val,posLen) {
            var cursorPosition = 0;
            if(dom.selectionStart){
                cursorPosition = dom.selectionStart;
            }
            this.insertAtCursor(dom,val);
            dom.focus();
            console.log(posLen)
            dom.setSelectionRange(dom.value.length,cursorPosition + (posLen || val.length));
        },

        /*光标所在位置插入字符*/
        insertAtCursor(dom, val) {
            if (document.selection){
                dom.focus();
                sel = document.selection.createRange();
                sel.text = val;
                sel.select();
            }else if (dom.selectionStart || dom.selectionStart == '0'){
                let startPos = dom.selectionStart;
                let endPos = dom.selectionEnd;
                let restoreTop = dom.scrollTop;
                dom.value = dom.value.substring(0, startPos) + val + dom.value.substring(endPos, dom.value.length);
                if (restoreTop > 0){
                    dom.scrollTop = restoreTop;
                }
                dom.focus();
                dom.selectionStart = startPos + val.length;
                dom.selectionEnd = startPos + val.length;
            } else {
                dom.value += val;
                dom.focus();
            }
        }
    }
};

export default Tool;
